<div class="content-info">
  <div class="content-title d-flex flex-column flex-md-row align-items-md-center justify-content-between">
    <h3 class="title mb-3 mb-md-0">Indent List</h3>
    <div class="title-actions d-flex flex-wrap align-items-center gap-2">
      <!-- Date filter -->
      <div class="form-group mb-0">
        <label class="mb-1">Date</label>
        <input type="date" class="form-control" [(ngModel)]="fromDate" (ngModelChange)="onLocationChange()"
          style="min-width: 150px;" />
      </div>

      <!-- Location selector -->
      <div class="form-group mb-0">
        <label for="locationSelect" class="mb-1">Select Locations</label>
        <ng-select style="min-width: 200px;" [items]="locations" [multiple]="true" bindLabel="name" bindValue="id"
          [closeOnSelect]="false" [clearable]="true" [(ngModel)]="selectedLocations" (change)="onLocationChange()"
          placeholder="Select locations">
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <input id="loc-{{ index }}" type="checkbox" [checked]="item$.selected" />
            {{ item.name }}
          </ng-template>

          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value">
              <span class="ng-value-label">{{ items[0]?.name }}</span>
              @if (items?.length > 1) {
              <span class="ng-value-label">&nbsp;and more</span>
              }
            </div>
          </ng-template>
        </ng-select>
      </div>

      <!-- Create Indent button -->
      <button class="btn btnprimary text-nowrap" [routerLink]="['create-indent']" style="margin-top: 24px;">
        <i class="bi bi-plus-lg"></i>Create Indent
      </button>
    </div>
  </div>

  <div class="common-table">
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table align-middle">
        <thead>
          <tr>
            <th scope="col" class="text-start text-nowrap">Indent Number</th>
            <th scope="col" class="text-start text-nowrap">Store Name</th>
            <th scope="col" class="text-start text-nowrap">Date</th>
            <th scope="col" class="text-start text-nowrap">Status</th>
          </tr>
        </thead>
        <tbody>
          @for (item of pagedIndentList; track trackById($index, item)) {
          <tr>
            <td class="text-start text-nowrap">
              <a [routerLink]="['/indent-list', item.id]" [queryParams]="{ view: true }" class="text-decoration-none">
                {{ item.indentNumber }}
              </a>
            </td>
            <td class="text-start">{{ item.storeName }}</td>
            <td class="text-start text-nowrap">{{ item.date | date: 'dd-MM-yyyy hh:mm a' }}</td>
            <td class="text-start text-nowrap">{{ item.status }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination [page]="currentPage" [limit]="pageSize" [pageCount]="pageCount"
      (pageChange)="goToPage($event)" (limitChange)="onPageSizeChange($event)">
    </app-pagination>
  </div>
</div>
<div class="modal fade" id="indentTypeModal" tabindex="-1" aria-labelledby="indentTypeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header border-bottom-0 pb-0">
        <h5 class="modal-title fw-bold" id="indentTypeModalLabel">
          Select Indent Type
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="loading = false"></button>
      </div>
      <div class="modal-body pt-2 pb-4">
        <!-- <div class="form-check mb-2">
          <input
            class="form-check-input"
            type="radio"
            name="indentType"
            id="flowThrough"
            value="FLOW"
            [(ngModel)]="selectedIndentType"
            />
          <label
            class="form-check-label fw-semibold text-dark"
            for="flowThrough"
            >
            Flow Through
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="indentType"
            id="nonFlowThrough"
            value="NON_FLOW"
            [(ngModel)]="selectedIndentType"
            />
          <label
            class="form-check-label fw-semibold text-dark"
            for="nonFlowThrough"
            >
            Non Flow Through
          </label>
        </div> -->
        <div class="form-check mb-2">
          <input class="form-check-input me-2" type="radio" name="indentType" id="flowThrough" value="FLOW"
            [(ngModel)]="selectedIndentType" />
          <label class="form-check-label fw-semibold text-dark" for="flowThrough">
            FT
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input me-2" type="radio" name="indentType" id="nonFlowThrough" value="NON_FLOW"
            [(ngModel)]="selectedIndentType" />
          <label class="form-check-label fw-semibold text-dark" for="nonFlowThrough">
            NFT
          </label>
        </div>
      </div>
      <div class="modal-footer flex-nowrap p-3 border-top-0">
        <button type="button" class="btn btn-secondary w-100 me-2" data-bs-dismiss="modal" (click)="loading = false">
          Cancel
        </button>
        <button type="button" class="btn btn-success w-100" [disabled]="!selectedIndentType" data-bs-dismiss="modal"
          data-bs-toggle="modal" data-bs-target="#confirmPoModal">
          Proceed
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="confirmPoModal" tabindex="-1" aria-labelledby="confirmPoModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title fw-bold" id="confirmPoModalLabel">
          Generate New PO?
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center p-4">
        <div class="mb-3">
          <i class="bi bi-question-circle text-primary fs-1"></i>
        </div>
        <p class="text-dark fw-semibold">
          You are about to generate
          <strong class="text-primary">Draft Purchase Orders.</strong>
        </p>
        <div class="text-start mb-3">
          <label class="form-label small text-muted mb-1">Warehouse</label>
          <!-- Replenishment POs are always raised FOR a warehouse -->
          <app-warehouse-select
            [locationTypes]="['Warehouse']"
            (selectionChange)="onWarehouseChange($event)"
          ></app-warehouse-select>
        </div>
        <p class="text-muted small mb-0">Are you sure you want to proceed?</p>
      </div>
      <div class="modal-footer flex-nowrap p-3 border-top-0">
        <button type="button" class="btn btn-secondary w-100 me-2" data-bs-dismiss="modal" (click)="loading = false">
          Cancel
        </button>
        <button type="button" class="btn btn-success w-100" (click)="confirmPoGeneration()">
          Generate
        </button>
      </div>
    </div>
  </div>
</div>